import type SolrQuery from '~/utils/solr/SolrQuery';
import type { SolrFacetCount } from '~/utils/solr/SolrQuery';

type SolrQueryResponse<T> = Promise<{
  data: Readonly<Ref<Array<NonNullable<T>>>>;
  numFound: Ref<number>;
  numFoundExact: Ref<boolean>;
  start: Ref<number>;
  facetCounts: Ref<Array<SolrFacetCount>>;
}>;

type SolrQueryParams = {
  q: SolrQuery;
};

export const useSolrQuery = async <T>({ q }: SolrQueryParams): SolrQueryResponse<T> => {
  const data: Ref<Array<NonNullable<T>>> = ref([]);
  const numFound: Ref<number> = ref(0);
  const numFoundExact: Ref<boolean> = ref(true);
  const start: Ref<number> = ref(0);
  const facetCounts: Ref<Array<SolrFacetCount>> = ref([]);

  const result = await q.query<NonNullable<T>>();
  data.value = result.docs;
  numFound.value = result.numFound;
  numFoundExact.value = result.numFoundExact;
  start.value = result.start;
  facetCounts.value = result.facetCounts;

  return {
    data,
    numFound,
    numFoundExact,
    start,
    facetCounts,
  };
};
